import { render } from "./DocumentClassSystemPromptSubView.vue?vue&type=template&id=784cea94&scoped=true&ts=true"
import script from "./DocumentClassSystemPromptSubView.vue?vue&type=script&lang=ts"
export * from "./DocumentClassSystemPromptSubView.vue?vue&type=script&lang=ts"

import "./DocumentClassSystemPromptSubView.vue?vue&type=style&index=0&id=784cea94&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-784cea94"]])

export default __exports__